<template>
    <div class="test-from-editor">
        <!-- {{testData}} -->
        <h2 class="question__title mb-6" :class="{'question__compact': question.length>200}" v-html="question"></h2>
        <div class="d-flex flex-column">
            <form @submit.prevent="onClickAnswer">
                <v-text-field v-model="answer" type="number" :step="1" _label="Выберите ответ" outlined :rules="[rules.required, rules.isNumber]" />
                <v-btn class="btn-disabled-primary mb-4 mx-auto" type="submit" x-large color="primary" :disabled="!answer" :loading="loading">
                    Продолжить
                </v-btn>
            </form>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'TestSimpleQuestion',
    data() {
        return {
            answer: 0,
            rules: {
                required: value => !!value || 'Введите значение',
                isNumber: v => !Number.isNaN(parseFloat(v)) || 'Введите число'
            },
        };
    },
    computed: {
        ...mapGetters({
            testData: 'testing/testing/testData',
            loading: 'testing/testing/loading',
            selectedAnswer: 'testing/testing/selectedAnswer',
        }),
        question() {
            return `<span>${this.testData.question.text}<span>`;
        },
    },
    watch: {
        testData: {
            immediate: true,
            handler() {
                this.answer = 0;
            },
        },
    },
    methods: {
        ...mapActions({
            sendAnswerText: 'testing/testing/sendAnswerText',
            setSelectedAnswer: 'testing/testing/setSelectedAnswer',
        }),
        onClickAnswer() {
            this.setSelectedAnswer(this.answer);
            this.sendAnswerText();
        },
    },
};
</script>

<style lang="scss">
</style>
